'use client';

import { CircleCheck } from 'lucide-react';

export default function IntegrationsSection() {
const nigeriaItems = [
{
label: 'INCOME TAX',
value: 'PAYE (Federal Inland Revenue)',
},
{
label: 'PENSION',
value: 'PenCom — 8% employee + 10% employer',
},
{
label: 'HOUSING FUND',
value: 'NHF — 2.5% of basic salary',
},
{
label: 'WORK INSURANCE',
value: 'NSITF — 1% of gross payroll',
},
{
label: 'SKILLS LEVY',
value: 'ITF — 1% of annual payroll',
},
];

const ghanaItems = [
{
label: 'INCOME TAX',
value: 'PAYE (Ghana Revenue Authority)',
},
{
label: 'BASIC PENSION',
value: 'SSNIT Tier 1 — 13% employer + 5.5% employee',
},
{
label: 'OCCUPATIONAL',
value: 'Tier 2 — mandatory, NPRA-regulated',
},
{
label: 'VOLUNTARY',
value: 'Tier 3 — provident fund or personal pension',
},
{
label: 'EDUCATION LEVY',
value: 'GETFund — 2.5% of gross salary',
},
];

return (
<section className="built-section" id="Integration">
<div className="built-container">
{/* Header */}
<div className="built-header">
<p className="built-label">BUILT FOR TWO MARKETS</p>

      <h2 className="built-title">
        One payroll platform.
        <br />
        <span>Two countries. Zero guesswork.</span>
      </h2>

      <p className="built-subtitle">
        Running payroll across Nigeria and Ghana usually means two
        <br className="desktop-break" />
        systems, two compliance calendars, two sets of headaches.
        <br className="desktop-break" />
        Avetium closes that gap entirely.
      </p>
    </div>

    {/* Country Cards */}
    <div className="built-grid">
      {/* Nigeria */}
      <div className="built-card">
        <div className="built-card-header nigeria">
          <div className="built-card-heading">
            <img
              src="/icons/nigeria.svg"
              alt="Nigeria flag"
              className="built-flag"
            />

            <div>
              <h3>Nigeria</h3>
              <p>Federal &amp; State compliance</p>
            </div>
          </div>
        </div>

        <div className="built-items">
          {nigeriaItems.map((item) => (
            <div className="built-item" key={item.label}>
              <div className="built-check nigeria">
                <CircleCheck size={16} strokeWidth={2.3} />
              </div>

              <div className="built-item-content">
                <span className="built-item-label">{item.label}</span>
                <p>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Ghana */}
      <div className="built-card">
        <div className="built-card-header ghana">
          <div className="built-card-heading">
            <img
              src="/icons/ghana.svg"
              alt="Ghana flag"
              className="built-flag"
            />

            <div>
              <h3>Ghana</h3>
              <p>NPRA &amp; GRA compliance</p>
            </div>
          </div>
        </div>

        <div className="built-items">
          {ghanaItems.map((item) => (
            <div className="built-item" key={item.label}>
              <div className="built-check ghana">
                <CircleCheck size={16} strokeWidth={2.3} />
              </div>

              <div className="built-item-content">
                <span className="built-item-label">{item.label}</span>
                <p>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>


);
}